import { Box, Breadcrumbs, Typography, Link, useTheme, Tabs, Tab } from '@mui/material';
import { SyntheticEvent } from 'react';
import { useIntl } from 'react-intl';

import { EditProjectControls } from './components/EditProjectControls';
import { ProjectAllocation } from './components/ProjectAllocation/ProjectAllocation';
import { ProjectOverview } from './components/ProjectOverview/ProjectOverview';
import { ProjectStats } from './components/ProjectStats';
import { ADMIN_PROJECT_TABS, type AdminProjectTabType } from './constants';
import { EditProjectProvider } from './context/EditProjectContext';
import { useProjectDetails } from './useProjectDetails';

export const ProjectDetails = () => {
  const { formatMessage } = useIntl();
  const theme = useTheme();

  const {
    projectId,
    initialEditMode,
    isProjectInactive,
    projectName,
    createdOn,
    startedOn,
    completedOn,
    selectedTab,
    handleTabChange,
    handleBackToProjects,
    isProjectDetailsLoading,
  } = useProjectDetails();
  return (
    <EditProjectProvider
      projectId={projectId}
      initialEditMode={initialEditMode}
      isProjectInactive={isProjectInactive}
    >
      <Box
        sx={{
          px: theme.spacing(6),
          py: theme.spacing(4),
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
        }}
      >
        <Box>
          <Breadcrumbs
            id="create-project-wizard-breadcrumbs"
            sx={{ fontSize: '16px' }}
            separator="/"
          >
            <Link
              color="inherit"
              underline="hover"
              onClick={handleBackToProjects}
              data-testid="breadcrumb-manage-projects"
              sx={{ cursor: 'pointer' }}
            >
              {formatMessage({ id: 'adminProjects.projectDetails.breadcrumb.adminProjects' })}
            </Link>
            <Link
              color="inherit"
              underline="none"
              data-testid="breadcrumb-create-project"
              sx={{ fontWeight: '500' }}
            >
              {projectName}
            </Link>
          </Breadcrumbs>
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            gap: theme.spacing(2),
          }}
        >
          <Typography variant="h4">{projectName}</Typography>
          <EditProjectControls />
        </Box>
        <Box id="project-summary-stats">
          <ProjectStats
            createdOn={createdOn}
            startedOn={startedOn}
            completedOn={completedOn}
            isLoading={isProjectDetailsLoading}
          />
        </Box>
        <Box id="admin-project-tab-selection">
          {/* <Tabs
                    value={selectedTab}
                    onChange={(event: SyntheticEvent, value: AdminProjectTabType) => handleTabChange(event, value)}
                    sx={{
                        mb: theme.spacing(5),
                        borderBottom: `1px solid ${theme.palette.divider}`,
                    }}
                >
                    <Tab
                        label={formatMessage({ id: 'adminProjects.projectDetails.tab.overview' })}
                        value={ADMIN_PROJECT_TABS.OVERVIEW}
                        sx={{
                            textTransform: 'none',
                            fontSize: '14px',
                            fontWeight: '500',
                        }}
                    /> */}
          {/* TODO: Implement allocation section once mockup is ready and finalized by Rob
                    <Tab
                        label={formatMessage({ id: 'adminProjects.projectDetails.tab.allocation' })}
                        value={ADMIN_PROJECT_TABS.ALLOCATION}
                        sx={{
                            textTransform: 'none',
                            fontSize: '14px',
                            fontWeight: '500',
                        }}
                    /> */}
          {/* </Tabs> */}
        </Box>
        <Box
          id="admin-project-details-content"
          sx={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}
        >
          {selectedTab === ADMIN_PROJECT_TABS.OVERVIEW && <ProjectOverview />}
          {selectedTab === ADMIN_PROJECT_TABS.ALLOCATION && <ProjectAllocation />}
        </Box>
      </Box>
    </EditProjectProvider>
  );
};
